// extracted by mini-css-extract-plugin
module.exports = {"button":"cluster-doc-snippet_button__giF41"};